import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomeModule)
  },
  {
    path: 'sign-up',
    loadChildren: () => import('./pages/signup/sign-up.module').then(m => m.SignUpModule)
  },
  {
    path: 'settings',
    loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule)
  },
  {
    path: 'content',
    loadChildren: () => import('./pages/content/content.module').then(m => m.ContentModule)
  },
  {
    path: 'relation-content',
    loadChildren: () => import('./pages/relation-content/relation-content.module').then(m => m.RelationContentModule)
  },
  {
    path: 'content-technical',
    loadChildren: () => import('./pages/content-technical/content-technical.module').then(m => m.ContentTechnicalModule)
  },
  {
    path: 'systemcheck',
    loadChildren: () => import('./pages/systemcheck/systemcheck.module').then(m => m.SystemcheckModule)
  },
  {
    path: 'events',
    loadChildren: () => import('./pages/events/events.module').then(m => m.EventsModule)
  },
  {
    path: 'schedule',
    loadChildren: () => import('./pages/schedule/schedule.module').then(m => m.ScheduleModule)
  },
  {
    path: 'account',
    loadChildren: () => import('./pages/account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'patient',
    loadChildren: () => import('./pages/patient/patient.module').then(m => m.PatientModule)
  },
  {
    path: 'speech-commant',
    loadChildren: () => import('./pages/speech-commant/speech-commant.module').then(m => m.SpeechCommantModule)
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'content'
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, paramsInheritanceStrategy: 'always', useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
